import {$} from './jquery-definition.js';
// import SmoothScroll from 'smooth-scroll';
import Cookies from 'js-cookie';
import {updateGoogleMapMarkersIcon} from "./modules/map";
import {animateInViewport} from "./transition";

// var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
// 	topOnEmptyHash: false,
// 	updateURL: false,
// 	speed: 1333,
// 	speedAsDuration: true,
// 	offset: function( anchor, toggle ) {
// 		// if ( $( 'body' ).hasClass( 'scroll-up' ) || $( 'body' ).hasClass( 'scroll-down' ) ) {
// 		// 	return $( '.site-header' ).outerHeight() * 2;
// 		// } else {
// 		// 	return $( '.site-header' ).outerHeight();
// 		// }
// 		return 50;
// 	},
// } );

$( function() {
	sanitizeTargetBlank();

	$( '.clinic-per-service button' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.parents( '.clinic-per-service' ).toggleClass( 'active' );
	} );

	$( '.primary-nav .menu > li' ).addClass( 'nav-item' );
	$( '.primary-nav .menu a' ).addClass( 'nav-link' );

	$( '.primary-nav .menu > .menu-item-has-children' ).hover( function() {
		var $this = $( this );

		$( '.site-header' ).addClass( 'sub-menu-hover' );

		$( '.sub-menu-hover-background' ).css( {
			'height': $this.find( '> .sub-menu' ).outerHeight() + $( '.navbar' ).outerHeight() + 30 + 'px',
		} );

		console.log( $this.find( '> .sub-menu' ).outerHeight() );
	}, function() {
		$( '.site-header' ).removeClass( 'sub-menu-hover' );

		$( '.sub-menu-hover-background' ).css( {
			'height': 0,
		} );
	} );

	$( '.privacy-policy-link' ).addClass( 'inverted-link' ).wrapInner( '<span></span>' );

	$( '.quicklinks a, .extra-info a' ).addClass( 'arrow-link' ).append( ' <span class="arrow arrow-right style-lys-frisk-gronn"><span class="far fa-angle-right"></span></span>' );

	$( '[data-toggle="collapse"], .expand-link' ).on( 'click', function() {
		var $this = $( this );

		var additionalToggle = $this.attr( 'data-addition-toggle' );
		if ( additionalToggle ) {
			$( additionalToggle ).toggleClass( 'expanded' );
		}

		$this.toggleClass( 'expanded' );
	} );

	$( '#open-mobile-menus' ).on( 'click', function() {
		$( 'body' ).addClass( 'open-mobile-menu' );
	} );

	$( '.close-menus' ).on( 'click', function() {
		$( 'body' ).removeClass( 'open-mobile-menu' );
	} );


	$( '.nav-link.search' ).on( 'click', function() {
		let $searchField = $( '.navbar .search-field' );

		if ( $( window ).width() < 1200 ) {
			if ( $( 'body' ).hasClass( 'open-mobile-menu' ) ) {
				$searchField = $( '.mobile-menu .mobile-header .search-field' );

			} else {
				$searchField = $( '.mobile-default-header .search-field' );
			}
		}

		$searchField.css( 'display', 'block' );
		setTimeout( function() {
			$searchField.focus();
		}, 100 );
		$searchField[ 0 ].setSelectionRange( 0, 0 );
	} );

	// Toggle
	$( '.toggle' ).on( 'click', function( clickEvent ) {
		var $this = $( this );
		var $target = $( $this.attr( 'data-target' ) );

		if ( $this.attr( 'href' ).length < 2 ) {
			clickEvent.preventDefault();
		}

		$this.toggleClass( 'active' );
		$target.toggleClass( 'active' );
		$( 'html' ).toggleClass( $this.attr( 'data-html-class' ) ).toggleClass( $this.attr( 'data-html-inactive-class' ) );
	} );

	var navTimeouts = [];
	$( '.site-navigation-control' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		if ( $( 'html' ).hasClass( 'active-menu' ) ) {
			$( '.mobile-site-navigation-container a' ).each( function( index ) {
				var $this = $( this );

				navTimeouts.push( setTimeout( function() {
					$this.addClass( 'active' );
				}, 200 + index * 125 ) );
			} );
		} else {
			$( '.mobile-site-navigation-container a' ).removeClass( 'active' );

			navTimeouts.forEach( function( timeout ) {
				clearTimeout( timeout );
			} );

			navTimeouts = [];
		}
	} );

	$( '.mobile-menu .sub-menu' ).wrap( '<div class="inner-smdop collapse"></div>' );
	$( '.mobile-menu .menu-item-has-children > a' ).append( ' <span><i class="far fa-angle-right"></i></span>' );
	$( '.mobile-menu .menu-item-has-children > a' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		$this.toggleClass( 'expanded' );
		$this.next().toggle( 300 );
	} );

	if ( $( window ).width() < 768 ) {
		$( '.block-clinic_finder .nav-link' ).on( 'click', function( clickEvent ) {
			clickEvent.preventDefault();

			var $this = $( this );

			$this.toggleClass( 'expanded' );
			$this.next().toggle( 300 );
		} );

		$( '.block-clinic_finder .nav-link' ).removeClass( 'active' );
	}

	$( '.simple-expander' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		var $target = $( $this.attr( 'data-target' ) );
		$target.toggle( 200 );
	} );

	$( '.dropdown-toggle, .dropdown-menu' ).hover( function() {
		$( 'body' ).addClass( 'menu-dropdown-active' );
	}, function() {
		$( 'body' ).removeClass( 'menu-dropdown-active' );
	} );

	var clinicFinderDown = false;
	$( '.clinic-finder-toggle' ).on( 'click', function() {
		var $clinicFinder = $( this ).parents( '.clinic-finder-container' ).find( '.clinic-finder' );

		$clinicFinder.slideToggle( 200, function() {
			if ( !clinicFinderDown && $( window ).width() < 768 ) {
				// Scroll to the #clinic element only after slide down animation completes
				$( 'html, body' ).animate( {
					scrollTop: $( '#clinic-finder-2' ).offset().top,
				}, 220 );
				clinicFinderDown = true;
			} else {
				clinicFinderDown = false;
			}
		} ).toggleClass( 'pointer-events-auto' );

		$( this ).find( '.icon' ).toggleClass( '!-rotate-180' );

		setTimeout( () => {
			animateInViewport();
		}, 225 );
	} );

	$( '.booking-widget-trigger' ).on( 'click', function() {
		const $this = $( this );
		const phone = $this.attr( 'data-clinic-phone' );
		const bookingWidgetId = $this.attr( 'data-booking-widget-id' );
		const bookingWidgetTreatmentId = $this.attr( 'data-booking-widget-treatment-id' );
		let text = '';

		if ( subtext ) {
			text = subtext.replace( '{{clinic_phone}}', '<a href="tel:' + phone + '" class="!underline hover:!no-underline">' + phone.replace( /(.{2})/g, '$1 ' ) + '</a>' );
		}

		const $bookingWidget = $( '.dentli-booking-widget-container .dentli-booking-widget' );
		const clinicName = $this.attr( 'data-clinic-name' );

		if ( phone ) {
			$( '.dentli-booking-widget-container .subtext' ).html( text ).show( 0 );
		} else {
			$( '.dentli-booking-widget-container .subtext' ).hide( 0 );
		}

		if ( bookingWidgetId ) {
			const widget = `
<div class="dentli_booking_container" data-dentli_ob_mode="quick-mini"
data-dentli_ob_id="${bookingWidgetId}"
${bookingWidgetTreatmentId ? 'data-dentli_ob_treatment_id="' + bookingWidgetTreatmentId + '"' : ''}
data-dentli_ob_show_text="false">
</div>
`;

			$( '.dentli-booking-widget-container .clinic-finder-toggle .h3-alt' ).html( clinicName );

			$bookingWidget.html( widget );

			window.registerComponents();

			$( '.clinic-finder-container' ).find( '.clinic-finder' ).slideUp( 100 ).removeClass( 'pointer-events-auto' );
			$( '.clinic-finder-toggle' ).find( '.icon' ).removeClass( '!-rotate-180' );
		}
	} );

	$( '.clinic-finder-2 .nav-link' ).on( 'click', function() {
		$( this ).parent().find( '.mobile-tab-pane-2' ).slideToggle( 200 );
		$( this ).find( '.arrow' ).toggleClass( 'max-md:!rotate-90 max-md:!-rotate-90' );
	} );

	$( '.clinic-finder-subtoggle' ).on( 'click', function() {
		$( this ).parents( '#filtering' ).find( '.filtering-group-container' ).slideToggle( 200 );
	} );

	$( '.site-content, .side-nav-wrp' ).on( 'click', function() {
		$( '.search-form.show' ).removeClass( 'show' );
	} );


	// Function to trigger click on anchor inside #booking-cta
	function triggerBookingAnchor() {
		$( '#booking-cta a.init-width-text, #booking-cta .clinic-finder-toggle' ).trigger( 'click' );
	}

	// Check if the URL hash is "#bookingCta" on page load
	if ( window.location.hash === '#booking-cta' ) {
		triggerBookingAnchor();
	}

	// Attach click event to links with href or part of href "#bookingCta"
	$( 'a[href*="#booking-cta"]' ).on( 'click', function( event ) {
		triggerBookingAnchor();
	} );

	$( '[data-toggle="tooltip"]' ).tooltip();

	$( '.financing-services-modal-links a' ).on( 'click', function() {
		const index = $( this ).index();
		setTimeout( () => {
			$( '.financing-services-modal-accordions .collapse-container' ).find( '.multi-collapse' )
				.each( function( i ) {
					if ( i === index ) {
						$( this ).collapse( 'show' );
					}
				} );
		}, 500 );
	} );

	$( '.location-filter' ).on( 'click', function() {
		if ( $( window ).width() < 992 ) {
			$( '.clinic-finder-subtoggle' ).click().find( '.h3-alt' ).html( $( this ).attr( 'data-label' ) );
		}
	} );

	$( '.sound-toggle' ).on( 'click', function() {
		// Find the closest video element within the same container
		var videoContainer = $( this ).closest( '.video-container' ); // Get the closest video container
		var video = videoContainer.find( 'video' ).get( 0 ); // Find the video element inside this container

		// Toggle the muted property
		video.muted = !video.muted;
		video.setAttribute( 'controls', 'controls' );

		// Update icons based on the muted state
		if ( video.muted ) {
			videoContainer.find( '.sound-on' ).addClass( 'hidden' ); // Hide sound-on icon
			videoContainer.find( '.sound-off' ).removeClass( 'hidden' ); // Show sound-off icon
		} else {
			videoContainer.find( '.sound-on' ).removeClass( 'hidden' ); // Show sound-on icon
			videoContainer.find( '.sound-off' ).addClass( 'hidden' ); // Hide sound-off icon
		}
	} );

	$( 'video' ).each( function() {
		var video = this; // Reference the current video element

		// Add 'ended' event listener
		video.addEventListener( 'ended', function() {
			// When the video ends, seek to 0.1 seconds and pause
			video.currentTime = 0.1;
			video.pause(); // Pause the video immediately after seeking
		} );
	} );

	$( '.clinic-finder-2-location-toggle' ).on( 'click', function( e ) {
		e.preventDefault(); // Prevent default behavior if this is a link
		const $navItemsContainer = $( this ).closest( '.nav-items-container' );
		const $container = $( this ).closest( '.clinic-finder-2' );
		const target = $( this ).attr( 'href' );

		const $currentSubNavItems = $( this ).closest( 'li' ).find( '.sub-nav-items' );

		// Check if the current sub-nav-items are already visible
		if ( $currentSubNavItems.is( ':visible' ) ) {
			// Close the current sub-nav-items
			$currentSubNavItems.slideUp( 200 );

			// Remove active class from the toggle and .arrow-link
			$( this ).removeClass( 'active' );
			$( this ).closest( 'li' ).find( '.arrow-link' ).removeClass( 'active' );

			// Deactivate the sub-nav
			$container.find( '.clinic-sub-nav' ).removeClass( 'active' );
			return; // Exit to prevent reopening
		}

		// Close all sub-nav-items within the container
		$container.find( '.sub-nav-items' ).slideUp( 200 );

		// Toggle the sub-nav-items in the current li
		$currentSubNavItems.stop( true, true ).slideToggle( 200 );

		// Remove active class from all toggle and .arrow-link elements
		$container.find( '.clinic-finder-2-location-toggle' ).removeClass( 'active' );
		$container.find( '.arrow-link' ).removeClass( 'active' );

		// Add the active class to the current toggle and .arrow-link
		$( this ).addClass( 'active' );
		$( this ).closest( 'li' ).find( '.arrow-link' ).addClass( 'active' );

		// Manage active state for the sub-nav
		$container.find( '.clinic-sub-nav' ).removeClass( 'active' );
		$container.find( target ).addClass( 'active' );
	} );

	$( '.toggle-booking-widget-container' ).on( 'click', function() {
		$( '.booking-widget-container' ).toggleClass( 'active' );

		$( this ).toggleClass( 'toggle-arrow-updown' );

		if ( $( window ).width() < 992 ) {
			$( this ).closest( '.cntcenter-wrp' ).find( '.booking-widget-container' ).toggle( 200 );
		}
	} );

	function toggleSpecialistClinic( $specialistClinic ) {
		$specialistClinic.toggleClass( 'specialist-clinics-information-shown' );
		$specialistClinic.toggleClass( '!bg-syrin' );
		$specialistClinic.find( '.hide, .show' ).toggleClass( 'hidden' );
		$specialistClinic.find( '.icon' ).toggleClass( '!-rotate-90' );
		$specialistClinic.closest( '.filtering-item' ).find( '.clinics-toggle-content ' ).toggle( 200 );
	}

	const $allSpecialistClinicsToggle = $( '.specialist-clinics-toggle' );
	$allSpecialistClinicsToggle.on( 'click', function() {
		const that = this;
		$allSpecialistClinicsToggle.each( function() {
			const $this = $( this );
			if ( this !== that && $this.hasClass( 'specialist-clinics-information-shown' ) ) {
				toggleSpecialistClinic( $this );
			}
		} );

		const $this = $( this );
		toggleSpecialistClinic( $this );
		updateGoogleMapMarkersIcon( ($this.hasClass( 'specialist-clinics-information-shown' ))
			? $this.closest( '.filtering-item' ).attr( 'data-clinic-Ids' ).split( ',' ).map( ( clinicId ) => `clinic-${clinicId}` )
			: [],
		);
	} );
} );

function closeMenu() {
	setTimeout( function() {
		$( 'body' ).removeClass( 'active-menu' );
		$( '.site-navigation-control, .mobile-site-navigation-container' ).removeClass( 'active' );
	}, 500 );
}

/**
 * Hide site menu on scroll down, show on scroll up
 */
var newScrollTop,
	currentScrollTop = 0,
	scrollTarget = $( 'body' );

$( window ).scroll( function() {
	var scrollTop = $( window ).scrollTop();

	if ( scrollTop > 50 ) {
		currentScrollTop = scrollTop;

		if ( newScrollTop < currentScrollTop ) {
			scrollTarget.addClass( 'scroll-down' );
			scrollTarget.removeClass( 'scroll-up' );
		} else if ( newScrollTop > currentScrollTop ) {
			scrollTarget.removeClass( 'scroll-down' );
			scrollTarget.addClass( 'scroll-up' );
		}
		newScrollTop = currentScrollTop;
	} else {
		scrollTarget.removeClass( 'scroll-down' );
		scrollTarget.removeClass( 'scroll-up' );
	}
} );

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}
